import axios from 'axios';

export default {
  findInvoice(accountId, period) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}accounts/${accountId}/invoices?period=${period}`);
  },

};